








import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { triggerWindowResizeEvent } from '@/utils/util'

// @ts-ignore
import zhCN from 'ant-design-vue/es/locale/zh_CN'

@Component({})
export default class App extends Vue {
	private locale: any = zhCN

	@Watch('$route')
	private onRouteChange(route: any) {
		this.$audioPlayer.close()
		this.$nextTick(() => {
			triggerWindowResizeEvent()
		})
	}

	private calcPage() {
		const pad: any = 16
		const header: any = document.querySelector('.ant-layout-header') || ''
		const headerHeight: any = header.offsetHeight || 0
		const content: any = document.querySelector('.content')
		const pageHeader: any = document.querySelector('.page-header')
		const multiTab: any = document.querySelector('.ant-pro-multi-tab') || ''
		const multiTabOffsetHeight = multiTab.offsetHeight || 0
		if (content && pageHeader) {
			// 针对详情页,ui设计tabs要脱离content,做特殊处理
			content.style.minHeight =
				window.innerHeight -
				headerHeight -
				pageHeader.offsetHeight -
				multiTabOffsetHeight -
				pad * 2 +
				'px'
			content.style.marginTop =
				pageHeader.offsetHeight + pad + multiTabOffsetHeight + 'px'
		}
	}

	private mounted() {
		window.addEventListener('resize', this.calcPage)
	}
}
